import {
  Box,
  Divider,
} from '@chakra-ui/react';
import React from 'react';
import PropTypes from 'prop-types';
import './SaveOnInsuranceStyles.css';

const Color = React.memo(
  ({ color }) => <Box bg={color} h="12px" w="12px" borderRadius="50%" />,
  (prevProps, nextProps) => prevProps.color === nextProps.color,
);

Color.propTypes = { color: PropTypes.string.isRequired };

function SaveOnInsurance() {
  function triggerPopupInParentPage() {
    console.log('Triggering parent popup');
    // const obieEvent = new Event('launchObieEvent');
    // window.parent.$('body').trigger('launchObieEvent');
    window.parent.postMessage('openInsuranceUI', '*');
    console.log('Posted message');
  }

  return (
    <>
      <div className="tabcontent12" id="save-on-insurance">
        <div className="save-on-insurance">
          <div className="save-on-insurance-text">
            <h3>Landlord Insurance that is right for you!</h3>
            <br />
            <ul>
              <li>Make sure you have the right coverage</li>
              <li>Check if you can save $100&apos;s on existing policy</li>
              <li>No phone call or hassle required</li>
            </ul>
            <button type="button" id="triggerInsurancePopup" onClick={triggerPopupInParentPage} className="primary-cta-button tertiary-button">Get an Instant Quote</button>
          </div>
          <div className="save-on-insurance-image">
            <img src="https://www.baselane.com/wp-content/uploads/2022/07/Content.png" srcSet="https://www.baselane.com/wp-content/uploads/2022/07/Content.png 1x, https://www.baselane.com/wp-content/uploads/2022/07/Content@2x.png 2x" alt="" />

          </div>
        </div>

        {/* <Modal */}
        {/*  isOpen={obieInitModalIsOpen} */}
        {/*  onAfterOpen={afterOpenObieInitModal} */}
        {/*  onRequestClose={closeObieInitModal} */}
        {/*  style={obieModalStyles} */}
        {/*  contentLabel="Save on Insurance" */}
        {/* > */}
        <div id="insurance-modal-wrap" className="mfp-hide">
          <div className="insurance-modal">
            <div className="obie-form">
              <form method="post" name="obie-form">
                <h3>Get an Instant Insurance Quote</h3>
                <div className="form-item">
                  <input type="text" id="location" name="obie-property-address" className="obie-property-address" placeholder="Enter property address" required />
                </div>
                <div className="form-item">
                  <input type="email" id="email" name="obie-email" className="obie-email" required placeholder="What's your email?" />
                </div>
                <button id="init-obie-button" type="submit" className="tertiary-button obie-form__button-submit">Get an Instant Quote</button>
              </form>

              <div className="obie-loading obie-loading--dark">
                <div className="lds-dual-ring" />
              </div>

              <div className="obie-results hide">
                <div className="obie-form-result">
                  <div className="obie-result-box">
                    <span className="obie-result-title">Property Insurance Estimate</span>
                    <p id="obie-results-value" />
                    <a href="/" id="obie-toggle-modal" name="modal-button" className="tertiary-button">Click here to insure your property</a>
                    <p id="obie-results-address" />
                    <img
                      src="https://www.baselane.com/wp-content/uploads/2021/12/Logo-Badge-White-BG.svg"
                      className="powered-by-obie"
                      height="32"
                      alt="Powered by Obie"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <script src="https://static.obierisk.com/sdk/obie.js" />
        <script src="https://www.baselane.com/wp-content/themes/baselane-theme/widgets/obie-form/obie-form-autocomplete-init.js" />
        <script src="https://www.baselane.com/wp-content/themes/baselane-theme/widgets/obie-form/obie-form.js" />
        {/* </Modal> */}
      </div>
      <Divider color="primary.100" my="4px" />
    </>
  );
}

SaveOnInsurance.propTypes = {};

export default React.memo(
  SaveOnInsurance,
);
